import { Component, Input, OnInit } from '@angular/core';
import { SearchTaskAssignment } from 'models/tasks/search-task-assignment';
import { environment } from '../../../../../environments/environment';
import { TaskService } from 'api-services/task.service';
import { SharedService } from 'services';
import { Router } from '@angular/router';
import { GridStateService } from 'services/grid-state.service';
import { TaskType } from 'shared/constant';

@Component({
  selector: 'app-contact-associated-task',
  templateUrl: './contact-associated-task.component.html',
  styleUrls: ['./contact-associated-task.component.css']
})
export class ContactAssociatedTaskComponent implements OnInit {
  @Input() userId: number = null;
  @Input() tenantId: number = null;
  @Input() taskTypeId: number = null;
  // @Input() isDeleted: boolean = false;
  @Input() branchId: number = null;
  @Input() userLicenseClassId: number = null;
  @Input() finraUserLicenseId: number = null;
  @Input() userAppointmentId: number = null;
  @Input() regulatoryActionId: number = null;
  
  taskList = [];
  showLoader: boolean = true;
  activeList: boolean = false;
  searchObj: SearchTaskAssignment = {} as SearchTaskAssignment;
  // profileUserId:number = localStorage['activeContactUserId'];
  selectedRecordId: number = null;
  gridStateName: string = "contact-associated-task";

  constructor(private taskService: TaskService, private gridStateService: GridStateService,
    private sharedService: SharedService,
    private router: Router) { }

  ngOnInit(): void {
    this.searchObj.pageNum = 1;
    this.searchObj.pageSize = 10;
    this.searchObj.sortOrder = 1;
    this.searchObj.search = "";
    this.searchObj.sortBy = "dueDate";
    this.searchObj.taskStatusIds = "1";
    this.searchObj.taskAssignedBy = null;
    this.searchObj.taskTypeId = this.taskTypeId;
    // this.searchObj.associatedWithId = this.branchId ? `B-${this.branchId}` : `U-${this.userId}`;
    this.taskTypeId ? '' : this.searchObj.associatedWithId = this.branchId ? `B-${this.branchId}` : `U-${this.userId}`;
    
    switch (this.taskTypeId) {
       case TaskType.Producer:
          this.searchObj.associatedWithId = `U-${this.userId}`;
         break;
        case TaskType.Branch:
          this.searchObj.associatedWithId = `B-${this.branchId}`;
         break;
        case TaskType.License:
          this.searchObj.userLicenseClassId = this.userLicenseClassId;
         break;
        case TaskType.Finra:
          this.searchObj.finraUserLicenseId = this.finraUserLicenseId;
         break;
        case TaskType.Appointment:
          this.searchObj.userAppointmentId = this.userAppointmentId;
         break;
        case TaskType.RegulatoryAction:
          this.searchObj.regulatoryActionId = this.regulatoryActionId;
         break;
        default:
          break;
    }
    
    this.getUserAssociatedTaskList();
  }

  getUserAssociatedTaskList(){

    this.taskService.getTasks(this.searchObj, false).subscribe(
      (response) => {
        this.taskList = response;

        this.taskList = this.taskList.map((el) => ({
          ...el,
          createdDate: this.sharedService.convertUTCTimeToLocalTime(el.createdDate),
          dueOn: this.sharedService.calculateDiff(el.dueDate),
          resolvedDate: this.sharedService.convertUTCTimeToLocalTime(el.resolvedDate),
        }));
        this.showLoader = false;
        this.activeList = true
      });

  }

  openTaskDetailModal(task){
    this.selectedRecordId = task.taskId;
    this.sharedService.sharedObj(task);
    sessionStorage.setItem('scrollToTask', 'true');
    this.router.navigate(['tasks/edit-task']);
  }

  loadURL() {
    //associatedWith Id
    //   this.searchObj.pageSize = Number(environment.pageSize);
    //  this.gridStateService.setState('list-task', {
    //   searchObj: this.searchObj,
    //   selectedFilter: null,
    //   selectedFilterName: null,
    //   filterCount : 2,
    //   scrollTop: 0,
    //   selectedRecordId: null
    // });

    // this.router.navigate(['/tasks']);
    localStorage.setItem("isAssocWidget", 'true');
    const associatedWithId: string = this.searchObj.associatedWithId;
    const taskTypeId: number = this.searchObj.taskTypeId
    this.router.navigate(['/tasks/associated-with'],{ state: { associatedWithId, taskTypeId } });
  }

onSortClick(event, colName) {
    let target = event.currentTarget,
      classList = target.classList;

    if (classList.contains('sorting-icon-asc')) {
      classList.remove('sorting-icon-asc');
      classList.add('sorting-icon-des');
      this.searchObj.sortBy = colName;
      this.searchObj.sortOrder = 1;
    } else {
      classList.add('sorting-icon-asc');
      classList.remove('sorting-icon-des');
      this.searchObj.sortBy = colName;
      this.searchObj.sortOrder = 0;
    }

    this.getUserAssociatedTaskList();
  }

  showTooltip(event: MouseEvent) {
    const tooltip = (event.target as HTMLElement).querySelector(
      '.text-tooltip'
    ) as HTMLElement;
    if (!tooltip) return;
    tooltip.style.display = 'block';

    const tooltipRect = tooltip.getBoundingClientRect();
    const targetRect = (event.target as HTMLElement).getBoundingClientRect();

    const spaceAbove = targetRect.top;
    const spaceBelow = window.innerHeight - targetRect.bottom;

    if (spaceBelow < tooltipRect.height && spaceAbove >= tooltipRect.height) {
      tooltip.classList.add('above');
      tooltip.classList.remove('below');
      tooltip.style.top = `-${tooltipRect.height - 28}px`;
      tooltip.style.left = '128%';
    } else {
      tooltip.classList.add('below');
      tooltip.classList.remove('above');
      tooltip.style.top = `${targetRect.height - 29}px`;
      tooltip.style.left = '128%';
    }
  }

  hideTooltip(event: MouseEvent) {
    const tooltip = document.querySelector(
      '.text-tooltip:hover'
    ) as HTMLElement;
    if (!tooltip) {
      const target = (event.target as HTMLElement).querySelector(
        '.text-tooltip'
      ) as HTMLElement;
      if (target) {
        target.style.display = 'none';
      }
    }
  }

  setGridStatus(){
     this.gridStateService.setState(this.gridStateName, {
      searchObj: this.searchObj,
      selectedRecordId: this.selectedRecordId
    });
  }
  

}
